export interface Product {
  id: string;
  name: string;
  type: string;
  price: number;
  description: string;
  productionTime: string;
  inStock: boolean;
  active: boolean;
  imageUrl: string;
  detailImageUrl: string;
}

export const products: Product[] = [
  {
    id: 'PRD-001',
    name: '12 Adet MDF Araç Logosu',
    type: 'arac_logo_set',
    price: 999,
    description: '12 farklı araç markası logosu, yüksek kaliteli MDF malzemeden özel kesim. Araç tutkunları için benzersiz bir dekoratif set.',
    productionTime: '3-5 iş günü',
    inStock: true,
    active: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Twelve%20MDF%20car%20logo%20emblems%20arranged%20on%20a%20dark%20wooden%20table%2C%20premium%20craftsmanship%2C%20golden%20lighting%20accents%2C%20professional%20product%20photography%20with%20soft%20shadows%2C%20minimal%20background&width=600&height=450&seq=product-prd-001-card&orientation=landscape',
    detailImageUrl: 'https://readdy.ai/api/search-image?query=Twelve%20MDF%20car%20logo%20emblems%20arranged%20on%20a%20dark%20wooden%20table%2C%20premium%20craftsmanship%2C%20golden%20lighting%20accents%2C%20professional%20product%20photography%20with%20soft%20shadows%2C%20minimal%20background&width=800&height=600&seq=product-prd-001-detail&orientation=landscape',
  },
  {
    id: 'PRD-002',
    name: 'İç Mekan Işıklı Tablo',
    type: 'isikli_tablo',
    price: 900,
    description: 'LED aydınlatmalı, özel tasarım iç mekan tablosu. Doğa manzaraları, şehir silüetleri ve özel tasarımlar mevcuttur.',
    productionTime: '5-7 iş günü',
    inStock: true,
    active: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Illuminated%20LED%20wall%20art%20painting%20with%20warm%20ambient%20glow%2C%20modern%20home%20interior%20decor%2C%20nature%20landscape%20design%2C%20elegant%20golden%20frame%2C%20cozy%20living%20room%20setting%20with%20soft%20lighting&width=600&height=450&seq=product-prd-002-card&orientation=landscape',
    detailImageUrl: 'https://readdy.ai/api/search-image?query=Illuminated%20LED%20wall%20art%20painting%20with%20warm%20ambient%20glow%2C%20modern%20home%20interior%20decor%2C%20nature%20landscape%20design%2C%20elegant%20golden%20frame%2C%20cozy%20living%20room%20setting%20with%20soft%20lighting&width=800&height=600&seq=product-prd-002-detail&orientation=landscape',
  },
  {
    id: 'PRD-003',
    name: 'Fener Tabela',
    type: 'fener_tabela',
    price: 2200,
    description: 'İşletmeler için özel tasarım ışıklı fener tabela. Dış mekana uygun, yüksek dayanıklılıkta malzeme.',
    productionTime: '7-10 iş günü',
    inStock: true,
    active: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Custom%20illuminated%20storefront%20lantern%20sign%20with%20elegant%20typography%2C%20traditional%20craftsmanship%20meets%20modern%20design%2C%20warm%20golden%20light%2C%20exterior%20building%20facade%2C%20dusk%20ambiance&width=600&height=450&seq=product-prd-003-card&orientation=landscape',
    detailImageUrl: 'https://readdy.ai/api/search-image?query=Custom%20illuminated%20storefront%20lantern%20sign%20with%20elegant%20typography%2C%20traditional%20craftsmanship%20meets%20modern%20design%2C%20warm%20golden%20light%2C%20exterior%20building%20facade%2C%20dusk%20ambiance&width=800&height=600&seq=product-prd-003-detail&orientation=landscape',
  },
  {
    id: 'PRD-004',
    name: 'Kişiye Özel İsimli Tablo',
    type: 'ozel_tasarim',
    price: 750,
    description: 'İstediğiniz isim veya yazı ile özel olarak tasarlanan ışıklı dekoratif tablo.',
    productionTime: '4-6 iş günü',
    inStock: true,
    active: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Personalized%20LED%20name%20sign%20with%20elegant%20cursive%20typography%2C%20warm%20pink%20ambient%20lighting%2C%20romantic%20bedroom%20decor%2C%20soft%20glowing%20effect%2C%20premium%20craftsmanship%20detail%20shot&width=600&height=450&seq=product-prd-004-card&orientation=landscape',
    detailImageUrl: 'https://readdy.ai/api/search-image?query=Personalized%20LED%20name%20sign%20with%20elegant%20cursive%20typography%2C%20warm%20pink%20ambient%20lighting%2C%20romantic%20bedroom%20decor%2C%20soft%20glowing%20effect%2C%20premium%20craftsmanship%20detail%20shot&width=800&height=600&seq=product-prd-004-detail&orientation=landscape',
  },
  {
    id: 'PRD-005',
    name: 'İşletmeye Özel Logo Tablo',
    type: 'ozel_tasarim',
    price: 1200,
    description: 'Firmanızın logosu ile özel olarak hazırlanan profesyonel ışıklı tablo. Ofis ve mağaza dekorasyonu için ideal.',
    productionTime: '5-7 iş günü',
    inStock: true,
    active: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Corporate%20custom%20logo%20LED%20wall%20sign%20for%20office%20reception%2C%20professional%20business%20decor%2C%20sleek%20design%20with%20company%20branding%2C%20modern%20lobby%20setting%2C%20sophisticated%20ambient%20lighting&width=600&height=450&seq=product-prd-005-card&orientation=landscape',
    detailImageUrl: 'https://readdy.ai/api/search-image?query=Corporate%20custom%20logo%20LED%20wall%20sign%20for%20office%20reception%2C%20professional%20business%20decor%2C%20sleek%20design%20with%20company%20branding%2C%20modern%20lobby%20setting%2C%20sophisticated%20ambient%20lighting&width=800&height=600&seq=product-prd-005-detail&orientation=landscape',
  },
  {
    id: 'PRD-006',
    name: 'Araç Temalı Özel Tasarım Tablo',
    type: 'ozel_tasarim',
    price: 1500,
    description: 'Klasik veya modern araç temalı, vintage görünümlü özel tasarım ışıklı tablo.',
    productionTime: '5-7 iş günü',
    inStock: true,
    active: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20car%20themed%20illuminated%20wall%20art%2C%20retro%20automotive%20design%2C%20amber%20warm%20lighting%2C%20nostalgic%20garage%20aesthetic%2C%20detailed%20classic%20automobile%20illustration%20with%20LED%20backlight&width=600&height=450&seq=product-prd-006-card&orientation=landscape',
    detailImageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20car%20themed%20illuminated%20wall%20art%2C%20retro%20automotive%20design%2C%20amber%20warm%20lighting%2C%20nostalgic%20garage%20aesthetic%2C%20detailed%20classic%20automobile%20illustration%20with%20LED%20backlight&width=800&height=600&seq=product-prd-006-detail&orientation=landscape',
  },
  {
    id: 'PRD-007',
    name: 'MDF Dekoratif Ürün',
    type: 'mdf_dekoratif',
    price: 150,
    description: 'Geometrik desenli, farklı boyutlarda MDF dekoratif duvar ürünleri. Set veya tekli olarak temin edilebilir.',
    productionTime: '2-4 iş günü',
    inStock: true,
    active: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Geometric%20MDF%20decorative%20wall%20panels%20set%2C%20modern%20minimalist%20design%2C%20natural%20wood%20texture%2C%20Scandinavian%20interior%20style%2C%20clean%20white%20wall%20background%2C%20soft%20daylight&width=600&height=450&seq=product-prd-007-card&orientation=landscape',
    detailImageUrl: 'https://readdy.ai/api/search-image?query=Geometric%20MDF%20decorative%20wall%20panels%20set%2C%20modern%20minimalist%20design%2C%20natural%20wood%20texture%2C%20Scandinavian%20interior%20style%2C%20clean%20white%20wall%20background%2C%20soft%20daylight&width=800&height=600&seq=product-prd-007-detail&orientation=landscape',
  },
];

export const productTypeLabels: Record<string, string> = {
  arac_logo_set: 'MDF Araç Logo Seti',
  isikli_tablo: 'İç Mekan Işıklı Tablo',
  fener_tabela: 'Fener Tabela',
  ozel_tasarim: 'Özel Tasarım',
  mdf_dekoratif: 'MDF Dekoratif Ürün',
};